export default "__VITE_ASSET__36b029bb__"